export default __webpack_public_path__ + "81e1f8d1171ab39e856a6fc170db0216.woff2";